import { Component, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
@Component({
    selector: 'app-indicador-pregunta',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './indicador-pregunta.component.html',
    styleUrls: ['./indicador-pregunta.component.scss'],
    standalone: false
})
export class IndicadorPreguntaComponent {
  @Input() form: FormGroup;
  @Input() pregunta: string;
  @Input() controlName: string;
  @Input() disabled: boolean = false;
  @Output() eventoCambioValor = new EventEmitter<boolean>();

  constructor() {}

  opcionSeleccionada(evento: KeyboardEvent, valor: boolean): void {
    if (evento.key === 'Enter') {
      this.cambioValor(valor);
    }
  }

  cambioValor(evento: any): void {
    const valor = evento.detail.value;
    this.form.get(this.controlName)?.setValue(valor);
    this.eventoCambioValor.emit(valor);
  }
  
}